import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetWarehousesValue, Warehouses } from '../models';

export const warehousesActions = createActionGroup({
    source: 'Warehouses',
    events: {
        'Get Warehouses': props<{ value: GetWarehousesValue }>(),
        'Get Warehouses Success': props<{ payload: Warehouses }>(),
        'Get Warehouses Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
